import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnvironmentPaginatorComponent } from './environment-paginator.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    EnvironmentPaginatorComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    IconsModule,

    FormsModule,
  ],
  exports: [
    EnvironmentPaginatorComponent
  ],
})
export class EnvironmentPaginatorrModule { }
